import type * as React from 'react';

import { Icon } from '@iconik-io/uad';

import VARIANTS from '../../constants/variants';
import FileButton from '../../ui/forms/fields/file_button/file_button';

import styles from './uploads_panel_widget.module.css';

type Props = {
  canUpload: boolean;
  isLoadingEntity: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};
const UploaderEmptyState: React.FC<Props> = ({
  canUpload,
  onChange,
  isLoadingEntity,
}) => (
  <div className={styles.empty_state}>
    {canUpload || isLoadingEntity ? (
      <>
        <Icon name="load_up" className={styles.empty_state_icon} />
        <FileButton
          name="files"
          className={styles.input_file}
          onChange={(event) => {
            if (!isLoadingEntity) {
              onChange(event);
            }
          }}
          message="Click or drop files/folders here"
          buttonProps={{
            className: styles.input_file_button,
            variant: VARIANTS.WHITE,
            noBorder: true,
          }}
          multiple
        />
      </>
    ) : (
      'You do not have permissions to upload here'
    )}
  </div>
);

export default UploaderEmptyState;
